const theme = {
  colors: {
    text: {
      primary: '#fff',
      grey: '#cbcbcb',
    },
    palette: {
      primary: '#3C4043',
      secondary: '#00A94F',
      lightPrimary: '#fff',
    },
    background: {
      /* TODO: @sarun edit this */
      primary: `linear-gradient(90deg, rgba(91,113,116,1) 0%, rgba(43,59,66,1) 100%)`,
    },
    grey: {
      medium: '#808080',
      light: '#cbcbcb',
    },
  },
  fontFamilies: {
    body: `Prompt, sans-serif`,
    title: `Prompt, sans-serif`,
  },
  fontWeights: {
    body: 300,
    title: 500,
  },
};

export default theme;
